import React from 'react';

import { ToggleButton } from '@mui/material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const HeadingSidebarForm = createBlockInputSection({
  title: 'Heading block',
  inputs: [
    {
      type: 'text',
      props: {
        rows: 3,
        label: 'Content',
        name: 'text',
        autofocus: true,
        autohighlight: true,
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Level',
        name: 'level',
        children: [
          <ToggleButton key={1} value="h1">
            H1
          </ToggleButton>,
          <ToggleButton key={2} value="h2">
            H2
          </ToggleButton>,
          <ToggleButton key={3} value="h3">
            H3
          </ToggleButton>,
        ],
      },
    },
    'color',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default HeadingSidebarForm;
